import { RecentlyViewed } from './RecentlyViewed';
import { CONTENT_MARGIN_BOTTOM } from '../constants/styling';
import { Flex } from 'foundations-components/components/Flex';
import { MostPopularTemplates } from './MostPopularTemplates';
import { CategoryContainer } from '../containers/CategoryContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AnalyticsSuite = ({
  categories,
  mostPopularTemplates
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: CONTENT_MARGIN_BOTTOM,
    children: [/*#__PURE__*/_jsx(RecentlyViewed, {}), mostPopularTemplates.length > 0 && /*#__PURE__*/_jsx(MostPopularTemplates, {
      templates: mostPopularTemplates
    }), categories.length > 0 && categories.map(category => /*#__PURE__*/_jsx(CategoryContainer, {
      category: category
    }, category.id))]
  });
};